import { createFileRoute } from '@tanstack/react-router';

import { TeachPhoebePage } from '@apps/web/features/teach_phoebe';

export const Route = createFileRoute('/_app/(main)/teach-phoebe')({
    component: TeachPhoebePage,
    head: () => ({
        meta: [{ title: 'Teach Phoebe | Phoebe' }],
    }),
});
